import styles from "./ConsultingDetail.module.css";
import SubPageTop from "../../components/SubPageTop";
import ScrollReveal from "../../components/Ui/ScrollReveal";
import { FiFilter, FiSliders, FiMonitor } from "react-icons/fi";
import React from "react";
const steps = [
  {
    icon: <FiFilter size={32} color="#ff5670" />,
    title: "주제별 분류",
    desc: [
      "영상, 광고 등을 주제별로 분류하여색채 분포 영역 설정",
      "주제별 명도, 채도 팔레트 및 주조색 먼셀값 추출",
    ],
  },
  {
    icon: <FiSliders size={32} color="#ff5670" />,
    title: "Web Palette 추출",
    desc: [
        "R.G.B, E.M.Y.K, COS, Pantone 등 컬러 시스템간 전환이 가능하도록 웹 팔레트 분포를 추출하여 영상 전체 배색, 톤 설정",
      ],
  },
  {
    icon: <FiMonitor size={32} color="#ff5670" />,
    title: "화면 적용",
    desc: [
        "주제와 메시지에 맞게 시각적 감성색채 이미지 구현의 정확도 확인 및 전체적 색감 검수",
      ],
  },
];

function EnterpriseGraphic() {
  return (
    <div className={styles.consultingDetail}>
      <SubPageTop title="Consulting" />
      <div className={styles.consultingDetailContent}>
        <ScrollReveal>
          <section className={styles.section01}>
          <div className={styles.imgbox}>
            <img
              src="/image/consulting-detail-section01-04.png"
              alt="컬러 이미지"
            />
          </div>
          <div className={styles.infoBox}>
            <div className={styles.infoHeader}>
              <p className={styles.subtitle}>Color Consulting</p>
              <p className={styles.koTitle}>그래픽 컬러 컨설팅</p>
            </div>
            <div className={styles.infoDetail}>
              <div className={styles.infoDesc}>
                그래픽 컬러디자인은,
                <br />
                영상, 광고, 방송의 시각이미지를 구성하는 감성색채를 활용하여
                메시지 전달이 가능하도록 구현합니다.
              </div>
              <ul className={styles.infoList}>
                <li>
                  <span className={styles.pointcolor}>·</span>
                  <span>
                    광고 및 영상 주제에 따른 효과적인 색채 커뮤니케이션 방안
                    제시
                  </span>
                </li>
                <li>
                  <span className={styles.pointcolor}>·</span>
                  <span>
                    ‘ ~다움’ 이 가능하도록 정체성, 비주얼 임펙트, 배색, 톤을
                    조정하여 수용자의 심리 및 색채 감성에 영향
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </section>
        </ScrollReveal>
        <ScrollReveal>
          <section className={styles.section02}>
          <div className={styles.titleWrap}>
            <p className={styles.programSubtitle}>process</p>
            <h2 className={styles.title}>컨설팅 프로세스</h2>
          </div>
          <div className={styles.line}></div>
          <div className={styles.steps}>
            {steps.map((step, i) => (
              <React.Fragment key={i}>
                <div className={styles.step}>
                  <div className={styles.iconWrap}>{step.icon}</div>
                  <div className={styles.textWrap}>
                    <div className={styles.stepTitle}>{step.title}</div>
                    <div className={styles.stepDesc}>
                      <div className={styles.stepDesc}>
                        {Array.isArray(step.desc) ? (
                          <ul>
                            {step.desc.map((text, idx) => (
                              <li key={idx}>{text}</li>
                            ))}
                          </ul>
                        ) : (
                          step.desc
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                {i < steps.length - 1 && (
                  <div className={styles.arrowWrap}>
                    <img
                      src="/image/arrow_right.png"
                      alt="arrow_right"
                      className={styles.arrow}
                    />
                  </div>
                )}
              </React.Fragment>
            ))}
          </div>
        </section>
        </ScrollReveal>
      </div>
    </div>
  );
}

export default EnterpriseGraphic;
